export default {"src":"/_next/static/media/ecotourism.e5852ba1.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};